import React, { useEffect } from "react";
import { logSparksEvent } from "@src/utils/sparks/logSparksEvent";
import { sanitizeCheckoutSessionUrl } from "@src/utils/sparks/sanitizeCheckoutSessionUrl";

/**
 * Fires a single product "page_view" event on mount.
 */
export const SparksPageView = ({ eventName }: { eventName: string }) => {
  useEffect(() => {
    void logSparksEvent({
      eventName,
      eventValue: typeof window !== "undefined" ? sanitizeCheckoutSessionUrl(window.location.href) : eventName,
    });
  }, [eventName]);

  return null;
};
